// ** React Imports
import { useMemo } from "react";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// #####################################################

const useCountryFilterData = () => {
	const { t } = useTranslation([
		"common",
		"filtersAndSelectors",
		"countries",
	]);
	const { country: countryName, countryId } = useSelector(
		(state) => state.mainPageRankings.location
	);
	const countryLocation = countryId
		? t(`countries:${countryId}`)
		: countryName || null;

	const language = useSelector((state) => state.globalCommon.language);

	const countryText = useMemo(() => {
		if (countryLocation) {
			return `${countryLocation ? `${countryLocation}` : ""}`;
		}
		return "";
	}, [countryLocation, language]);

	// ** Filtr - Kraj
	const countryFilterData = useMemo(() => {
		return countryText
			? {
					label: t("filtersAndSelectors:countryLabel"),
					selected: countryText,
			  }
			: null;
	}, [countryText, language]);

	// #####################################################

	return countryFilterData;
};

// #####################################################

export default useCountryFilterData;

// #####################################################
